
const heating_options = {
    "powder_coating_curing_oven": {
        "title": "Powder Coating Curing Oven",
        options: [
            {
                "text": "Electrical Heaters",
                "children": []
            },
            {
                "text": "L.P.G. Direct Flame Heating.",
                "children": []
            },
            {
                "text": "L.P.G. Indirect R.G.T. Heating.",
                "children": []
            },
            {
                "text": "LPG/Diesel Fired Heat Exchanger.",
                "children": []
            }
        ]
    }
}


const recovery_booth_pollution_free =
{
    "title": "Recovery Booth Pollution Free",
    "text": "Powder Coating Mono-Cyclonic Recovery Spray Booth  ",
    "description": "Mono Cyclonic Recovery System is a revolutionary new concept becoming popular in Indian powder coating market. Mono- cyclonic systems gives excellent 98% over sprayed powder recovery. Mono- cyclonic systems are widely used at the places where we require large volumes powder coating recovery efficiency for application. ",
    items: {
        "title": "Mono Cyclonic Recovery Systems four major parts:",
        "text": "Mono Cyclonic Recovery Systems four major parts:",
        "items": [
            {
                "title": "BOOTH",
                "description": "BOOTH: The enclosed zone in which gun operator applies virgin powder film through electrostatic charging is called booth, this is the effective volume in which powder coating process takes place.",
                "children": []
            },
            {
                "title": "MONO-CYCLONE",
                "description": "MONO-CYCLONE: In Mono-Cyclonic Recovery System , one cyclone of large diameter introduced depending upon the effective working volume of the enclosure for suction the powder. Since powder enters from the top of the clone through the stabilizing chamber. Light weight powder particles(unusable) separate from the over sprayed powder & goes into discharge duct and heavy weight powder particles(usable) collect in the bottom bin of the cyclone.",
                "children": []
            },
            {
                "title": "BLOWER",
                "description": "BLOWER: This is mounted at the end of the vertical cylinder to suck out the air from the booth along with over sprayed powder particles. Over sprayed powder particles get settled due to gravitational force in the collector bin at the conical end of cyclone.",
                "children": []
            },
            {
                "title": "DUST COLLECTOR",
                "description": "DUST COLLECTOR: This duct is always attached to blower to discharge the over fine particles of powder collected during the recovery of over sprayed powder from booth.",
                "children": []
            }
        ]
    }
}

const cyclone = {
  title: 'Cyclone',
  text: 'Cyclone',
  description: 'A powder coating cyclone system is a highly efficient, pollution-free recovery method that captures over 98% of oversprayed powder. By using centrifugal force to spin the air, it separates loose powder particles from the exhaust. This creates a closed-loop, environmentally friendly process that eliminates waste and prevents dust from polluting the air.',
  items: {
    title: 'Key Environmental & Performance Benefits',
    text: 'Key Environmental & Performance Benefits',
    items: [
      {
        title: 'Virtually Zero Emissions',
        description: 'Powder coatings emit almost zero Volatile Organic Compounds (VOCs). The cyclone captures airborne particles so only clean exhaust exits the facility.',
        children: [],
      },
      {
        title: 'Maximized Efficiency',
        description: 'Up to 98% of the excess powder that misses your target object is sucked into the cyclone. It is then reclaimed into a hopper and automatically mixed with fresh powder for reuse.',
        children: [],
      },
      {
        title: 'Pollution Control Compliance',
        description: 'Keeps your workspace safe by meeting strict industrial emission limits, preventing hazardous waste, and avoiding harmful air spillage.',
        children: [],
      },
    ],
  },
}

const dust_collector = {
  title: 'Dust Collector',
  text: 'Dust Collector',
  description: 'A "pollution-free" powder coating dust collector is an industrial filtration system designed to capture airborne powder overspray while emitting virtually zero hazardous air pollutants. These systems allow facilities to reclaim up to 99% of unused powder for reuse while safely returning filtered, breathable air back into the workspace.',
  items: {
    title: 'How These Systems Achieve "Pollution-Free" Status',
    text: 'How These Systems Achieve "Pollution-Free" Status',
    items: [
      {
        title: 'Zero VOCs',
        description: 'Powder coatings are inherently solvent-free and emit negligible to no Volatile Organic Compounds (VOCs).',
        children: [],
      },
      {
        title: 'No Hazardous Waste',
        description: 'By trapping the overspray in high-efficiency filters, the system prevents fine dust from exhausting into the atmosphere or accumulating as solid waste.',
        children: [],
      },
      {
        title: 'Air Recirculation',
        description: 'Instead of venting the air outside, high-efficiency cartridge filters clean the air so thoroughly that it can be safely circulated directly back into the facility. This also saves significant energy by keeping heated or cooled shop air indoors.',
        children: [],
      },
      {
        title: 'Sustainable Zero-Waste Finishing',
        description: 'Unlike traditional liquid paints, which require costly and complex air-scrubbing equipment to manage evaporating solvents, a powder coating dust collector relies entirely on mechanical filtration. When properly maintained, it keeps the work environment OSHA-compliant, protects workers from respiratory irritation, and creates a highly sustainable, zero-waste finishing loop.',
        children: [],
      },
    ],
  },
}

const powder_transfer_system = {
  title: 'Powder Transfer System',
  text: 'Powder Transfer System',
  description: 'In a powder coating plant, a Powder Transfer System (PTS) acts as the circulatory system, moving fine thermoplastic or thermoset polymer powders seamlessly between storage containers, reclaiming hoppers, and the spray guns. Instead of heavy manual pouring—which creates thick dust clouds, wastes material, and causes surface defects from contamination—automated pneumatic transfer keeps the air pristine and guarantees a smooth, high-quality finish.',
  items: {
    title: 'Crucial Applications Within a Powder Coating Line',
    text: 'Crucial Applications Within a Powder Coating Line',
    items: [
      {
        title: 'Fresh Powder Feed (Box-to-Hopper)',
        description: 'Transfers fresh paint powder directly from its original shipping box or a giant bulk bag into the centralized spray hopper or powder center. Specialized "box feed units" use vibrating pickup tubes to suck out 99% of the powder without manual lifting.',
        children: [],
      },
      {
        title: 'Overspray Reclamation & Recovery',
        description: 'During the electrostatic spraying process, up to 40% of the powder does not stick to the target metal part. A vacuum PTS pulls this airborne overspray out of the spray booth filter cartridges or cyclone separator and sends it back to be reused.',
        children: [],
      },
      {
        title: 'Recycle & Virgin Blending',
        description: "The system automatically transfers both reclaimed powder and new virgin powder into an intermediate storage unit, mixing them in exact proportions so the recycled material doesn't compromise the final coating quality.",
        children: [],
      },
      {
        title: 'Automatic Sifting & Sieving',
        description: 'Before reaching the gun, the system pushes the powder through an inline high-frequency ultrasonic or rotary sieve. This traps dirt, clumps, and metal flakes, preventing "spitting" and ensuring a flawless finish.',
        children: [],
      },
    ],
  },
};

const pre_treatment_process_steps = {
    9: {
        "title": "Pre Treatment Process",
        "text": "Pre Treatment Process",
        "description": "",
        steps: [
            {
                "text": "Degreasing (heated, insulated and FRP coated inner walls)",
                "children": []
            },
            {
                "text": "Water Rinsing-1",
                "children": []
            },
            {
                "text": "De-rusting (FRP coated inner wall)",
                "children": []
            },
            {
                "text": "Water Rinsing – 2",
                "children": []
            },
            {
                "text": "Activation",
                "children": []
            },
            {
                "text": "Phosphating (Heated, insulated and FRP coated inner walls)",
                "children": []
            },
            {
                "text": "Water Rinsing – 3",
                "children": []
            },
            {
                "text": "Passivation (Heated, insulated and FRP coated inner walls)",
                "children": []
            },
            {
                "text": "Water Rinsing-4",
                "children": []
            },
            {
                "text": "Water Dry Off Oven",
                "children": []
            }
        ]
    }
}

const gem_automatic_system = {
    electrical_cabinet: {
        "title": "OptiFlex AS10 electrical cabinet",
        "text": "OptiFlex AS10 electrical cabinet (Manufactured Locally)",
        "description": "",
        "items": [
            "Freestanding  base cabinet, equipped with pneumatic unit, including air filter/regulator and air connection sockets for control units",
            "Modular upper structure designed to accommodate Gema master control , gun controls, reciprocator controls, powder hopper controls"
        ],
        technical_specification: {
            power_supply: {
                "title": "Power Supply",
                "text": "Power Supply",
                "description": "",
                data: [
                    {
                        "Parameter": "Standard",
                        "Value": "3x400 VAC+N+PE / 50/60Hz",
                    },
                    {
                        "Parameter": "US Market",
                        "Value": "100-120 V 60Hz",
                    },
                ]
            },
            technical_data: {
                "title": "Technical Data",
                "text": "Technical Data",
                "description": "",
                data: [
                    {
                        "Parameter": "Width",
                        "Value": "600 [mm]",
                    },
                    {
                        "Parameter": "Depth (incl. base)",
                        "Value": "300 (550) [mm]",
                    },
                    {
                        "Parameter": "Max height",
                        "Value": "1'880 [mm]",
                    }

                ]
            }
        }
    },
    gun_control: {
        "title": "OptiStar 4.0 CG20 gun control",
        "text": "OptiStar 4.0 CG20 gun control",
        "description": "The new benchmark for gun controls",
        "items": [
            "3 pre-set standard application programs and 250 user definable application programs - easy operation for beginners / powerful functions for the experts",
            "PCC technology to optimize the electrostatic charging even for challenging powders",
            "DVC technology grants the most precise and repeatable powder output settings",
            "Powder output calibration function, allowing for identical powder output at identical settings for all guns of a powder coating line, irrespective of their individual powder hose length",
            "Adjustment function to temporally change the powder output, without modifying the selected application program",
            "Wear part monitoring by working hours counters for the main wear parts",
            "Bluetooth connectivity to Gema E-App allowing device setup, application parameter adjustments and line data monitoring via mobile device",
            "Key pad lock to prevent unintended user input",
            "Diagnostics module and error code indication for easy trouble shooting",
            "Rinsing mode to remove powder accumulations from the injector, powder hose and gun"
        ]
    },
    automatic_gun: {
        "title": "OptiGun GA03 automatic gun",
        "text": "OptiGun GA03 automatic gun",
        "description": "More powder on the parts - less in the recovery",
        "items": [
            "Based on Gema corona charging technology",
            "Integrated 100 kV high power cascade for unmatched first pass transfer efficiency",
            "Equipped with high efficiency nozzle, ensuring highest quality application results",
            "Wide selection of special nozzles available as option",
            "Robust design, optimized for fast & reliable color change as well as low & easy maintenance",
            "Designed for use of organic and metallic powders"
        ]
    },
    manual_gun: {
        "title": "OptiSelect GM04 manual gun",
        "text": "OptiSelect GM04 manual gun",
        "description": "The manual gun for maximum coating performance",
        "items": [
            "Based on Gema corona charging technology",
            "Integrated 110 kV PowerBoost technology based cascade for unmatched first pass transfer efficiency",
            "Equipped with high efficiency nozzle, ensuring highest quality application results",
            "Wide selection of special nozzles available as option",
            "On-gun remote control to adjust all coating parameters",
            "Robust design, light weight and very ergonomic design",
            "Optimized for fast & reliable color change as well as low & easy maintenance",
            "Designed for use of organic and metallic powders"
        ]
    },
    injector: {
        "title": "OptiFlow IG07 injector",
        "text": "OptiFlow IG07 injector",
        "description": "The first choice in injector technology for high performance powder conveying",
        "items": [
            "Single-component Inline Cartridge Design and 135° open angle design reduces wear consumption, guarantees a long term consistent powder flow and enables even faster wear part exchange",
            "Designed to work with Gema DVC Technology",
            "All connections equipped with quick release couplings - Plug & Convey",
            "Robust die-cast housing",
            "Designed for mounting on fluidized powder hopper, includes suction tube"
        ]
    },
    hopper: {
        "title": "HF100 powder hopper",
        "text": "HF100 powder hopper (Manufactured Locally)",
        "description": "",
        "items": [
            "High quality fluidized bed, designed to accommodate up to 12 injectors",
            "Opening for automatic powder supply and opening with lid for manual powder supply and inspection",
            "Easy to clean stainless steel construction",
            "Opening to accommodate level probe",
            "Air mover",
            "Technical data: Diameter 24 mm Height 600 mm Capacity 100 l"
        ],
        technical_specification: {
            "title": "Technical Data",
            "text": "Technical Data",
            "description": "",
            "data": [
                {
                    "Parameter": "Diameter",
                    "Value": "24 mm"
                },
                {
                    "Parameter": "Height",
                    "Value": "600 mm"
                },
                {
                    "Parameter": "Capacity",
                    "Value": "100 l"
                }
            ]
        }
    },
    caster: {
        "title": "Caster for HF Powder Hoppers",
        "text": "Caster for HF Powder Hoppers",
        "description": "Based on standard industrial equipment, casters for HF (such as Gema HF02-100/150/200) powder hoppers require robust, typically 3 to 4-inch, non-marking swivel casters, often with brakes for stability on concrete floors. ",
        "data": ["Based on standard industrial equipment, casters for HF (such as Gema HF02-100/150/200) powder hoppers require robust, typically 3 to 4-inch, non-marking swivel casters, often with brakes for stability on concrete floors. "]
    },
    powder_hopper_control: {
        "title": "OptiAir CA12 powder hopper control",
        "text": "OptiAir CA12 powder hopper control",
        "description": "Ideal for optimal powder conditioning",
        "items": [
            "Manual pressure regulators and pressure gauges for fluidizing and air mover",
            "Manual pre-fluidizing function to \"loosen up\" compacted powder"
        ]
    },
    reciprocator_control_unit: {
        "title": "OptiMove CR08 reciprocator control unit",
        "text": "OptiMove CR08 reciprocator control unit",
        "description": "The most powerful and user-friendly reciprocator control",
        "items": [
            "Control unit for one Gema ZA reciprocator or XT axis",
            "Clear interface for an intuitive operation",
            "Stores and recalls reciprocator programs for an easier automated operation of the line. More reproducible coating results!",
            "Different operating modes to meet every need:",
            "Oscillating mode, with up to 250 programs; each program consists of lower reverse point, upper reverse point and speed",
            "Positioning mode, with up to 250 programs; each program consists of end position and speed. Typical for horizontal XT axis",
            "Sequential mode, with up to 250 program steps; realize complex movement cycles, consisting of individual segments with different end positions and speeds",
            "Installation in the OptiFlex AS cabinet"
        ],
        technical_data: {
            "title": "Technical Data",
            "text": "Technical Data",
            "description": "",
            data: [
                {
                    "Parameter": "Positioning error",
                    "Value": "< 5 [mm]"
                }
            ]
        }
    },
    reciprocator: {
        "title": "ZA10-18 Reciprocator",
        "text": "ZA10-18 Reciprocator",
        "description": "The easy solution for your automation needs",
        "items": [
            "Reliable trouble-free operation with minimum maintenance costs",
            "Smooth acceleration, ideal for the best coating results",
            "Vertical carriage with plastic rollers and belt drive",
            "Synchronous motor"
        ],
        technical_data: {
            "title": "Technical Data",
            "text": "Technical Data",
            "description": "",
            data: [
                { "Parameter": "Height", "Value": "2760 [mm]" },
                { "Parameter": "Width (base)", "Value": "550 [mm]" },
                { "Parameter": "Width (column)", "Value": "250 [mm]" },
                { "Parameter": "Depth", "Value": "750 [mm]" },
                { "Parameter": "Stroke", "Value": "1800 [mm]" },
                { "Parameter": "Speed", "Value": "0.08 to 0.6 [m/s]" },
                { "Parameter": "Acceleration", "Value": "0.1 – 2.0 [m/s²]" },
                { "Parameter": "Max load", "Value": "25 [kg]" },
                { "Parameter": "Power consumption", "Value": "0.4 [kVA]" },
                { "Parameter": "Max cable length to the CR control", "Value": "20 [m]" }
            ]
        }
    },
    trolley_for_manual_displacement_of_one_reciprocator: {
        "title": "Trolley for manual displacement of one reciprocator",
        "text": "Trolley for manual displacement of one reciprocator",
        "description": "",
        "items": [
            "Base trolley",
            "Rollers and locking clamps",
            "Handles to move the reciprocator"
        ]
    },
    gun_supports: {
        "title": "Gun supports",
        "text": "Gun supports",
        "description": "Gema automatic powder gun supports include specialized gun mounts, holders, and mounting shafts designed for integration with reciprocators, axes, and automatic coating booths",
        "items": []
    },
    installation_training: {
        "title": "Installation and Training",
        "text": "Installation and Training",
        "description": "",
        "items": [
            "A certified Gema specialist engineer will be deployed on-site to perform complete system commissioning, including calibration of spray guns, powder feed units, and control systems to Gema factory standards.",
            // "Hands-on operator training will be provided covering equipment operation, process parameter optimization, powder management, and color-change procedures to ensure efficient and confident day-to-day use.",
            "The engineer will also conduct preventive maintenance and fault diagnosis training, enabling your team to independently handle routine upkeep and troubleshoot issues, minimizing unplanned downtime."
        ]
    },
}

const includes = {
    generic_manual_gun: {
        title: "Manual Gun",
        text: "Manual Gun",
        description: "",
        headers: [
            "Component",
            "Quantity"
        ],
        data: [
            {
                "Component": "Manual Gun",
                "Quantity": "1"
            },
            {
                "Component": "Control Unit",
                "Quantity": "1"
            }, {
                "Component": "Trolley",
                "Quantity": "1"
            }, {
                "Component": "Hopper",
                "Quantity": "1"
            }
        ]
    },
    actual_manual_gun: {
        title: "Gema Manual Powder Coating Unit Model OptiFlex-Pro ",
        text: "Gema Manual Powder Coating Unit Model OptiFlex-Pro ",
        description: "",
        headers: [
            "Component",
            "Quantity"
        ],
        data: [
            {
                "Component": "Gema OptiStar Control Unit",
                "Quantity": "1"
            },
            {
                "Component": "Gema Opti Gun with 6 mtrs Cable and 6 mtrs Powder Hose",
                "Quantity": "1"
            }, {
                "Component": "Gema OptiFlow Injector",
                "Quantity": "1"
            }, {
                "Component": "Local Powder Hopper Capacity 30 kg",
                "Quantity": "1"
            },
            {
                "Component": "Local Trolley",
                "Quantity": "1"
            }
        ]
    }
}

const commercial_offer = {
    title: "Commercial Offer",
    text: "Commercial Offer",
    description: "",
    headers: [
        "Item",
        "Quantity",
        "Price"
    ],
    data: [
        {
            "Item": "Oven",
            "Quantity": "1 set",
            "Price": "23,00,000"
        },
        {
            "Item": "Over Head Conveyor",
            "Quantity": "1 set",
            "Price": "10,00,000"
        },
        {
            "Item": "Pollution Free Booth",
            "Quantity": "1 set",
            "Price": "25,00,000"
        },
        {
            "Item": "Pre Treatment Set",
            "Quantity": "1 set",
            "Price": "40,00,000"
        },
        {
            "Item": "Gema Auto Guns",
            "Quantity": "6 sets",
            "Price": ""
        },
        {
            "Item": "Gema Manual Guns",
            "Quantity": "2 sets",
            "Price": ""
        },
        {
            "Item": "100 Lit Local Make Hopper",
            "Quantity": "1 set",
            "Price": ""
        },
        {
            "Item": "PP01 Recovery Pump",
            "Quantity": "1 set",
            "Price": "40,00,000"
        },
        {
            "Item": "Gema Sieve Machine",
            "Quantity": "1 set",
            "Price": ""
        },
        {
            "Item": "Gema Reciprocators",
            "Quantity": "2 set",
            "Price": ""
        },
        {
            "Item": "Gema Electrical Cabinet",
            "Quantity": "1 set",
            "Price": ""
        }
    ]
}
const terms_and_conditions = {

    generic: {

    }
};

export {
  heating_options,
  recovery_booth_pollution_free,
  cyclone,
  dust_collector,
  powder_transfer_system,
  pre_treatment_process_steps,
  gem_automatic_system as GEMA_Automatic_System,
  includes,
  commercial_offer,
  terms_and_conditions,
};